<div>
    Bank Charges Account:
    <nz-select name="bankChargesAccountId" [(ngModel)]="bankChargesAccountId" nzAllowClear nzShowSearch class="dropdown-width">
        <nz-option *ngFor="let opt of glAccs" [nzLabel]="opt.code + ' - ' + opt.name" [nzValue]="opt.id"></nz-option>
    </nz-select>
</div>
